module.exports = __webpack_public_path__ + "img/ant.8e3c5ff9.png";